import * as React from 'react';

function SvgPound(props) {
  return (
    <svg viewBox="0 0 10 14" fill="none" {...props}>
      <path
        d="M5.39.43c1.011 0 1.988.213 2.93.64l-.593 1.422c-.844-.37-1.584-.554-2.22-.554-1.067 0-1.6.57-1.6 1.71v1.907h3.1v1.343h-3.1V8.32c0 .474-.087.878-.259 1.211-.171.334-.466.617-.882.852h5.906V12H.562v-1.523c.51-.157.889-.407 1.133-.75.245-.344.367-.808.367-1.391V6.898H.595V5.555h1.469v-2c0-.98.294-1.745.882-2.297C3.54.706 4.355.43 5.391.43z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgPound;
